import {INotificacao} from '@models/conta/notificacao.ts';
import {DefaultInformationProps} from '@models/DefaultProps.ts';
import {Grid, Link, TableCell, TableRow, Typography} from '@mui/material';
import {ToDateString} from '@shared/MathHelp.ts';
import React from 'react';
import {Link as RouterLink} from 'react-router';

export interface NotificacaoInfoProps extends Omit<DefaultInformationProps<INotificacao>, 'variant'> {
	type: 'grid' | 'fullGrid' | 'row';
}

export const NotificacaoInfo: React.FC<NotificacaoInfoProps> = (props) => {
	return (<NotificacaoInfoRow {...props}/>);
};

export const NotificacaoInfoGrid: React.FC<Omit<NotificacaoInfoProps, 'type' | 'EndComponent'>> = (props) => {
	const {value} = props;
	
	return (<Grid>
		{value.mensagem}
	</Grid>);
};

export const NotificacaoInfoRow: React.FC<Omit<NotificacaoInfoProps, 'type' | 'EndComponent'>> = (props) => {
	const {value} = props;

	return (<TableRow>
		<TableCell>{value.id}</TableCell>
		<TableCell><Typography color={value.tipo.toLowerCase()}>{value.mensagem}</Typography></TableCell>
		<TableCell>{ToDateString(value.data, "DD/MM/YYYY HH:mm")}</TableCell>
		<TableCell>{value.tipo}</TableCell>
		<TableCell>{value.urlAoClicar && <Link component={RouterLink} to={value.urlAoClicar}>Ir</Link>}</TableCell>
	</TableRow>);
};